const Icons = [
  {
    name: "Power",
    x: "12",
    y: "52",
    url:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FPower.PNG?v=1618917340364",
    hover:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FPower%20Hover.PNG?v=1618917340623",
  },
  {
    name: "Expression",
    x: "68",
    y: "64",
    url:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FExpression.PNG?v=1618917340489",
    hover:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FExpression%20hover.PNG?v=1618917340883",
  },
  {
    name: "Freedom",
    x: "32",
    y: "19",
    url:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FFreedom.PNG?v=1618917339855",
    hover:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FFreedom%20Hover.PNG?v=1618917339942",
  },
  {
    name: "Harmony",
    x: "68",
    y: "28",
    url:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FHarmony.PNG?v=1618917341570",
    hover:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FHarmony%20Hover.PNG?v=1618917341505",
  },
  {
    name: "Isolation",
    x: "34",
    y: "87",
    url:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FIsolation.PNG?v=1618917339280",
    hover:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FIsolation%20Hover.PNG?v=1618917340125",
  },
  {
    name: "Listening",
    x: "2",
    y: "75",
    url:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FListening.PNG?v=1618917339447",
    hover:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FListening%20Hover.PNG?v=1618917340847",
  },
  {
    name: "Moving",
    x: "5",
    y: "30",
    url:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FMoving.PNG?v=1618917339915",
    hover:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FMoving%20Hover.PNG?v=1618917339340",
  },
  {
    name: "Self Love",
    x: "70",
    y: "10",
    url:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FSelf%20Love.PNG?v=1618917340420",
    hover:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FSelf%20Love%20Hover.PNG?v=1618917339556",
  },
  {
    name: "WW",
    x: "18",
    y: "0",
    url:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FWW.PNG?v=1618917339279",
    hover:
      "https://cdn.glitch.com/515ab27d-c76a-4bec-be1f-9a3e70c6c94d%2FWW%20Hover.PNG?v=1618917341059",
  },
];

export default Icons;
